<template>
  <v-main>
    <v-container
      fluid
      fill-height
      style="
        background-color: rgba(5, 82, 62, 0.04);
        overflow-x: auto;
        white-space: nowrap;
      "
    >
      <v-layout justify-center style="min-width: 1000px">
        <v-col>
          <v-card style="width: 100%" class="elevation-0" color="transparent">
            <v-toolbar color="transparent" flat>
              <!-- 상단 바 -->
              <div style="display: flex; margin-left: 20px">
                <v-icon color="#05523E" size="50">mdi-clipboard-text</v-icon>
                <div
                  style="font-size: 32px; font-weight: bold; margin-left: 10px"
                >
                  Orders
                </div>
              </div>
              <v-spacer />
              <template v-slot:extension>
                <v-tabs color="#05523E" v-model="tab" align-with-title>
                  <v-tabs-slider color="#05523E" />
                  <v-tab v-for="item in items" :key="item.tabName">
                    {{ item.tabName }}
                  </v-tab>
                </v-tabs>
              </template>
            </v-toolbar>
            <v-tabs-items
              touchless
              v-model="tab"
              style="margin-top: 20px; margin-left: 3%; width: 95%"
            >
              <v-tab-item color="transparent">
                <InvoiceList ref="order" />
              </v-tab-item>
              <v-tab-item color="transparent">
                <ShortageList ref="shortage" />
              </v-tab-item>
            </v-tabs-items>
          </v-card>
        </v-col>
      </v-layout>
    </v-container>
  </v-main>
</template>

<script>
import InvoiceList from "@/components/Orders/InvoiceList.vue";
import ShortageList from "@/components/Orders/ShortageList.vue";

export default {
  components: {
    InvoiceList,
    ShortageList,
  },
  data() {
    return {
      tab: null,
      items: [{ tabName: "Invoice" }, { tabName: "Shortage" }],
    };
  },
  props: {
    source: String,
  },
  watch: {
    tab: async function (newVal, preVal) {
      // console.log(pre,newVal)
      if (newVal == 1) {
        this.$nextTick(async () => {
          await this.$store.dispatch("invoice/getCategory");
          await this.$refs.shortage.getShortageAll();
        });
      } else {
        this.$nextTick(async () => {
          if (this.$refs.order) {
            await this.$refs.order.getInvoiceListLength(true);
            await this.$refs.order.getInvoiceList(true);
          }
        });
      }
    },
  },
  async created() {
    this.$store.commit("common/changeSelectedMenu", { selectedMenu: 1 });
  },
};
</script>
